module.exports = __webpack_public_path__ + "static/media/inktoberPaperWitch.252b970c.gif";